/**
 * Constants should be added here.
 */
export class EasePortalConstants {
    // Used when we need to redirect the user to a specific route,
    static readonly REDIRECT_TO_ROUTE = 'redirectToRoute';

    /**
     * Application's available routes
     */
    static readonly APP_ROUTES = {
        HOME: 'home',
        DASHBOARD: 'requests',
        PROFILE: 'profile',
        SEARCH: 'search',
        INITIAL_REQUEST: 'request-submission',
        GUIDANCE: 'guidance',
        PAGE404: 'not-found',
        PAGE403: 'forbidden',
        PAGE500: 'internal-server-error',
        CASE: 'case',
        TERMS_AND_CONDITIONS: 'terms',
        CONFIRMATORY_REQUEST: 'confirmatory',
        REVIEW: 'ask-for-review'
    };
    // Key holding the payload sent by Reg doc platform
    static readonly EXTERNAL_SYSTEM_LOCAL_STORAGE_KEY = 'externalSystemData';
    static readonly EXTERNAL_SYSTEM_DATA_TIMESTAMP = 'externalSystemDataTimestamp';
    // After that time (in minutes) the external system data above will expire
    static readonly EXTERNAL_SYSTEM_DATA_EXPIRE_TIME = 1;
    static readonly SEARCH_RESULTS_SIZE = 20;
    static readonly SEARCH_DEBOUNCE_TIME = 1500;
    static readonly LOCAL_STORAGE_SEARCH_CRITERIA_KEY = 'searchCriteria';

    static readonly EXTERNAL_SYSTEMS = {
        REG_DOC: { GET_PARAMETER: 'regDocData' },
        REG_COM: { GET_PARAMETER: 'regComData' }
    };

    /**
     * Is the number of pagination items right and left of current page in pagination
     */
    static readonly PAGINATION_OFFSET = 2;

    static readonly BREADCRUMB_DATA = 'breadcrumbData';
    static readonly CONFIRMATORY_STORAGE_KEY = 'confirmatoryRequest';
    static readonly TABLE_PAGE_SIZE = 10;
    static readonly COMMUNICATION_FILTER_RESULTS_SIZE = 5;

    /**
     * Application's available fragments keys
     */
    static readonly APP_FRAGMENTS = {
        TERMS: 'terms_and_conditions',
        GUIDANCE_TIP_2: 'what_can_i_request',
        GUIDANCE_TIP_3: 'what_about_infringement',
        GUIDANCE_TIP_4: 'how_can_i_submit_request'
    };
    /**
     * Default file max size in bytes
     */
    static MAX_SIZES = {
        // system's max file size in bytes for communication tab for an attachment
        COMMUNICATION_MAX_FILE_SIZE: 0,
        // system's max file size in bytes for communication tab for all attachments
        COMMUNICATION_MAX_FILE_SIZE_ALL_DOCUMENTS: 0,
        // system's max file size in bytes for initial or confirmatory requests for an attachment
        REQUESTS_MAX_FILE_SIZE: 0,
        // system's max file size in bytes  for initial or confirmatory requests for all attachments
        REQUESTS_MAX_FILE_SIZE_ALL_DOCUMENTS: 0
    };
    /**
     *
     */
    static MAINTENANCE_INFORMATION = {
        // The starting moment when the message should be displayed
        MAINTENANCE_START_DATETIME: null,
        // The ending moment when the message should be displayed
        MAINTENANCE_STOP_DATETIME: null,
        // The timezone of the starting date
        MAINTENANCE_START_TIMEZONE: null,
        // The timezone of the ending date
        MAINTENANCE_STOP_TIMEZONE: null
    };
    /**
     * In miliseconds
     */
    static readonly EDITOR_DEBOUNCE_TIME = 15000;
    static readonly FILE_EXTENSIONS = ['docx', 'pdf', 'odt', 'rtf', 'txt', 'doc'];

    /**
     * Is a parameter from properties file which will
     * be replaced from document reference
     */
    /*eslint no-template-curly-in-string: "off"*/
    static readonly DOC_REFERENCE_PARAMETER = '${docRef}';
    /**
     * Is a parameter from properties file which will
     * be replaced from session language
     */
    static readonly SESSION_LANGUAGE_PARAMETER = '${sessionLang}';

    /**
     * The language that user choose
     */
    static readonly LOCAL_STORAGE_LANGUAGE_CHOICE_KEY = 'lang';

    static readonly UPLOAD_FILE_PAGE_TYPE = {
        REQUESTS: 'requests',
        COMMUNICATION: 'communication'
    };
}
